import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {}

const CopyIcon: React.FC<IProps> = props => {
  return (
    <svg {...props} width="18" height="22" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.58325 4.41309V16.0798H9.70825V4.41309H1.58325ZM1.37492 3.16309C0.799622 3.16309 0.333252 3.62946 0.333252 4.20475V16.2881C0.333252 16.8634 0.799622 17.3298 1.37492 17.3298H9.91658C10.4919 17.3298 10.9583 16.8634 10.9583 16.2881V4.20475C10.9583 3.62946 10.4919 3.16309 9.91658 3.16309H1.37492Z"
        fill="#072D83"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.29874 0.666636C3.95357 0.664662 3.67215 0.942879 3.67018 1.28805C3.6682 1.63322 3.94642 1.91464 4.29159 1.91662L12.3123 1.9625V10.038C12.3123 10.3832 12.5922 10.663 12.9373 10.663C13.2825 10.663 13.5623 10.3832 13.5623 10.038V1.41124C13.5648 1.38937 13.5661 1.36716 13.5662 1.34466C13.5682 0.999489 13.29 0.718071 12.9448 0.716096L4.29874 0.666636Z"
        fill="#072D83"
      />
    </svg>
  );
};
export default React.memo(CopyIcon);
